// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon--1AlEI","Increase":"Increase--2vOrl","Decrease":"Decrease--3HI22","Stagnate":"Stagnate--1l7ti","Small":"Small--1LQLP","Large":"Large--3rN6U"};